/* eslint-disable angular/file-name */
// TODO: move this file to common api!
angular.module('zc.zenclerkS')
  .factory('ZcsProject', ZcsProject);

ZcsProject.$inject = ['$q', '$translate', 'Api', 'Project', 'projectServiceRequestTransformer', 'projectServiceResponseTransformer'];
function ZcsProject($q, $translate, Api, Project, projectServiceRequestTransformer, projectServiceResponseTransformer) {
  const PROFIT_RATE_OPTIONS = () => [
    { value: 10, label: '10-15%' },
    { value: 15, label: '15-20%' },
    { value: 20, label: '20-25%' },
    { value: 25, label: '25-30%' },
    { value: 30, label: '30-35%' },
    { value: 35, label: '35-40%' },
    { value: 40, label: '40-45%' },
    { value: 45, label: '45-50%' },
    { value: 50, label: $translate.instant('services.zcsProject.moreThan', { number: '50%' }) },
  ];

  const AVERAGE_CONVERSION_PRICE_OPTIONS = currency => [
    { value: 500, label: $translate.instant('services.zcsProject.lessThan', { number: currency.symbol + '1,000' + currency.suffix }) },
    { value: 1000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '1,000' + currency.suffix }) },
    { value: 2000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '2,000' + currency.suffix }) },
    { value: 3000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '3,000' + currency.suffix }) },
    { value: 4000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '4,000' + currency.suffix }) },
    { value: 5000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '5,000' + currency.suffix }) },
    { value: 6000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '6,000' + currency.suffix }) },
    { value: 7000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '7,000' + currency.suffix }) },
    { value: 8000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '8,000' + currency.suffix }) },
    { value: 9000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '9,000' + currency.suffix }) },
    { value: 10000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '10,000' + currency.suffix }) },
    { value: 11000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '11,000' + currency.suffix }) },
    { value: 12000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '12,000' + currency.suffix }) },
    { value: 13000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '13,000' + currency.suffix }) },
    { value: 14000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '14,000' + currency.suffix }) },
    { value: 15000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '15,000' + currency.suffix }) },
    { value: 16000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '16,000' + currency.suffix }) },
    { value: 17000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '17,000' + currency.suffix }) },
    { value: 18000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '18,000' + currency.suffix }) },
    { value: 19000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '19,000' + currency.suffix }) },
    { value: 20000, label: $translate.instant('services.zcsProject.moreThan', { number: currency.symbol + '20,000' + currency.suffix }) },
  ];

  const service = {
    all,
    get,
    remove,
    saveProject,
    PROFIT_RATE_OPTIONS,
    AVERAGE_CONVERSION_PRICE_OPTIONS
  };

  return service;

  function all(userId) {
    return Api.get(`/api/users/${userId}/projects`, {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer,
    })
      .then(function(res) {
        if(!res.data.success) {
          $q.reject(res);
          return;
        }
        return _.filter(res.data.projects, {product_line: 'zenclerk_s'});
      });
  }

  function get(userId, apikey) {
    if(!apikey) { return $q.reject(null) }
    return Api.get(`/api/users/${userId}/projects/${apikey}`, {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer,
    })
      .then(function(res) {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.project;
      });
  }

  function remove(userId, apikey) {
    return Api.delete(`/api/users/${userId}/projects/${apikey}`);
  }

  function saveProject(project) {
    return Project.update(
      { projectId: project.id },
      { project },
      {
        transformRequest: projectServiceRequestTransformer,
        transformResponse: projectServiceResponseTransformer,
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/zcs_project.service.js